import { Suspense, useEffect, useMemo } from 'react'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom'
import { Loading } from '@winnin/winnin_ui.components.loading'

import { WidthWrapper } from 'components'
import TabsList from 'components/TabsList'
import { OwnedTopicsTab } from 'modules/territory'
import { PanelStore } from 'stores'
import { analyticsTracker } from 'utils'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import WinninTopicsTab from './components/WinninTopicsTab'
import type { TTerritoryTab } from './search-territories-page.types'

import './index.scss'

export default function SearchTerritoriesPage() {
  const location = useLocation()
  const history = useHistory()
  const workspaceId = Object(PanelStore?.selectedPanel)?.panelId

  const baseUrl = getRoute(PATHNAMES.WORKSPACE_TOPICS, { panelId: workspaceId })

  const handleTrack = (tab: TTerritoryTab) => {
    const keyToTitle = {
      territories: 'Winnin Topics',
      owned: 'Owned Topics',
    }
    const { TOP_OPEN_SEARCH } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(TOP_OPEN_SEARCH, {
      'Page name': 'Topics',
      'Tab title': keyToTitle[tab],
    })
  }

  const tabs = useMemo(() => {
    return [
      {
        path: `${baseUrl}/territories`,
        label: 'Winnin topics',
        isBlocked: false,
        key: 'territories',
      },
      {
        path: `${baseUrl}/owned`,
        label: 'Owned topics',
        isBlocked: false,
        key: 'owned',
      },
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const pathname = location.pathname.split('/')
    const currentTab = pathname?.[pathname?.length - 1]
    const currentTabs = tabs.map(item => item.key)
    if (!currentTabs.includes(currentTab)) {
      const territoriesTab = getRoute(PATHNAMES.WORKSPACE_TOPICS, {
        panelId: workspaceId,
        topicsType: 'territories',
      })
      history.replace(territoriesTab)
    }
  }, [history, location.pathname, tabs, workspaceId])

  useEffect(() => {
    const pathname = location.pathname.split('/')
    const currentTab = pathname?.[pathname?.length - 1]
    if (['territories', 'owned'].includes(currentTab)) {
      handleTrack(currentTab as TTerritoryTab)
    }
  }, [location.pathname])

  return (
    <div className="SearchTerritoriesPage-wrapper">
      <WidthWrapper className="widthWrapper">
        <TabsList tabs={tabs} />
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route path={`${baseUrl}/territories`}>
              <WinninTopicsTab />
            </Route>
            <Route path={`${baseUrl}/owned`}>
              <OwnedTopicsTab />
            </Route>
          </Switch>
        </Suspense>
      </WidthWrapper>
    </div>
  )
}
